import React from 'react';
import { Button, Tooltip, Typography } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { fct } from '../../../fct/tokens/tokens';

const { Text } = Typography;

interface FilaComparadaProps {
  /** Etiqueta del campo (columna izquierda de la rejilla). */
  label: string;
  obligatorio?: boolean;
  /** Control/valor del registro provisional. */
  provisional: React.ReactNode;
  /** Control/valor del cliente existente (o `—` si no hay cliente cargado). */
  existente: React.ReactNode;
  /**
   * Si se pasa, se pinta la flecha de copia campo a campo (izq→dcha) entre
   * las dos columnas — pantallazo GDeco `Validacion_Altas_Tratamiento.png`.
   * La copia en bloque no existe (ajuste 8 firme).
   */
  onCopiar?: () => void;
  copiarDeshabilitado?: boolean;
}

/**
 * Fila de la rejilla de comparación provisional/existente (spec §6.2) — una fila por campo,
 * con banda gris continua en la columna de flechas (ajuste 9) y sin rojo en obligatorios
 * (solo asterisco; la obligatoriedad se comprueba al ejecutar la acción — ajuste 12).
 * COPIADO CON REVISIÓN del mockup T05 (FUENTE_HISTORICA): en la revisión solo cambia el
 * import de los tokens `fct` (ruta relativa del repo real en vez del alias `@/` de Vite).
 */
export const FilaComparada: React.FC<FilaComparadaProps> = ({
  label,
  obligatorio,
  provisional,
  existente,
  onCopiar,
  copiarDeshabilitado,
}) => (
  <div
    style={{
      display: 'grid',
      gridTemplateColumns: '130px 1fr 28px 1fr',
      columnGap: 12,
      alignItems: 'center',
      borderBottom: `1px solid ${fct.linea.fila}`,
    }}
  >
    <Text type="secondary" style={{ fontSize: 12, padding: '8px 0' }}>
      {label} {obligatorio && '*'}
    </Text>
    <div style={{ padding: '8px 0' }}>{provisional}</div>
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        alignSelf: 'stretch',
        background: fct.superficie.hundida,
      }}
    >
      {onCopiar && (
        <Tooltip title="Copiar este dato del provisional al existente">
          <Button
            size="small"
            type="text"
            icon={<ArrowRightOutlined />}
            disabled={copiarDeshabilitado}
            onClick={onCopiar}
          />
        </Tooltip>
      )}
    </div>
    <div style={{ padding: '8px 0' }}>{existente}</div>
  </div>
);
